export default __webpack_public_path__ + "static/media/GAMEAE_logo_white.d923c022.png";